import React, { Component } from 'react'
import { Switch, withRouter } from 'react-router-dom'
import { Layout as AppLayout, ConfigProvider } from 'antd'
import { connect } from 'react-redux'
import loadable from '@loadable/component'

import localeTh from 'antd/es/locale/th_TH'
import localeEn from 'antd/es/locale/en_US'

import '../../../styled/common.css'
import '../../../styled/mapmarker.css'
import 'ant-design-pro/dist/ant-design-pro.css'
import 'moment/locale/th'
import 'moment/locale/en-au'

import * as authActions from 'modules/auth/actions'
import * as uiActions from 'modules/ui/actions'
import PrivateRoute from './PrivateRoute'
import Header from './Header'
import VoicePanel from 'modules/voice/components/VoicePanel'
import LangContext, { i18n } from 'modules/shared/context/langContext'
//////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////
////////                      Site Page                           ////////
//////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////

import OauthLogin from 'modules/oauth/components/OauthLogin'
import Maintenancedevice from 'modules/help/maintenancedevice/components/Maintenancedevice'
import Scoresummary from 'modules/reports/scoresummary/components/Scoresummary'
import Behaviordrivingbycompany from 'modules/reports/behaviordrivingbycompany/components/Behaviordriving'
import Behaviordriving from 'modules/reports/behaviordriving/components/Behaviordriving'
import Honeytoastplayback from 'modules/monitoring/honeytoastplayback/components/Honeytoastplayback'
import Honeytoastplaybackwebpage from 'modules/monitoring/honeytoastplaybackwebpage/components/Honeytoastplayback'
import Honeytoastdownloadfile from 'modules/monitoring/honeytoastdownloadfile/components/Honeytoastdownloadfile'
import Honeytoastdownloadfilewebpage from 'modules/monitoring/honeytoastdownloadfilewebpage/components/Honeytoastdownloadfile'
import Honeytoaststream from 'modules/monitoring/honeytoaststream/components/Video'
import HoneytoaststreamV2 from 'modules/monitoring/honeytoaststream-v2/components/Video'
import Deliverytrip from 'modules/delivery-management/delivery-trip/components/Trip'
import Servicerepairdevice from 'modules/help/servicerepairdevice/components/Servicerepairdevice'
import Contactmanagement from 'modules/management/contactmanagement/components/Contactmanagement'
import HomeDashboard from 'modules/home-dashboard/index/components/HomeDashboard'
import Fueluse from 'modules/reports/fueluse/components/Fueluse'

import Policy from 'modules/setting/policy/components/Policy'
import NotificationSetting from 'modules/setting/notification-setting/components/NotificationSetting'
import LineNotify from 'modules/setting/linenotify/components/LineNotify'

import GpsPerformanceDashboard from 'modules/monitoring/gps-performance-dashboard/components/GpsPerformanceDashboard'
import SafetyDashboard from 'modules/monitoring/safety-dashboard/components/SafetyDashboard'
import RepairingReport from 'modules/reports/repairingreport/components/RepairingReport'
import PartnerPerformReport from 'modules/reports/partnerperformreport/components/PartnerPerformReport'
import GpsVendorPayingSummaryReport from 'modules/reports/gpsvendorpayingsummaryreport/components/GpsVendorPayingSummaryReport'
import GpsVendorPayingReport from 'modules/reports/gpsvendorpayingreport/components/GpsVendorPayingReport'
import FuelNotification from 'modules/reports/fuelNotification/FuelNotification'

import Datavisibility from 'modules/master-data/datavisibility/components/Datavisibility'
import SummaryDashboard from 'modules/monitoring/summary-dashboard/components/SummaryDashboard'
import Profile from 'modules/management/profile/components/Profile'

import Schedulereport from 'modules/reports/schedulereport/components/Schedulereport'
import SummaryVehicleUsage from 'modules/reports/summary-vehicle-usage/Overviews'
import Routemaster from 'modules/delivery-management/route-master/components/Routemaster'

import Uom from 'modules/master-data/uom/components/Uom'
import Product from 'modules/master-data/product/components/Product'

import Trackingstatusdashboard from 'modules/tracking_status_dashboard/tracking_status/components/Trackingstatusdashboard'
import Smartdispatching from 'modules/smartdispatching/components/Smartdispatching'

import Distancereport from 'modules/reports/distancereport/components/Distancereport'
import Webcontent from 'modules/web-content/components/WebContent'
import GenerateUserToken from 'modules/master-data/generate-user-token/components/GenerateUserToken'
import LogisticCommandCenter from './logistic-command-center'
import NotificationProvider from './NotificationProvider'

const VehicleContract = loadable(() =>
  import('modules/master-data/vehicle-contract/VehicleContractOverview'),
)

const Vehicleinformationdlt = loadable(() =>
  import(
    'modules/reports/vehicleinformationdlt/components/Vehicleinformationdlt'
  ),
)

const Alarmalertbyplateno = loadable(() =>
  import('modules/reports/alarmalertbyplateno/components/Alarmalert'),
)
const Alarmalertbyplatenoonyear = loadable(() =>
  import('modules/reports/alarmalertbyplatenoonyear/components/Alarmalert'),
)
const Alarmalertbydriver = loadable(() =>
  import('modules/reports/alarmalertbydriver/components/Alarmalert'),
)
const Alarmalertbydurationtime = loadable(() =>
  import('modules/reports/alarmalertbydurationtime/components/Alarmalert'),
)
const Drivingbehavior = loadable(() =>
  import('modules/reports/drivingbehavior/components/Alarmalert'),
)
const Drivinglicensescanbehavior = loadable(() =>
  import(
    'modules/reports/drivinglicensescanbehavior/components/Drivinglicensescan'
  ),
)
const Separatevehiclestatus = loadable(() =>
  import('modules/reports/separatevehiclestatus/components/Routereport'),
)
const Comparevehiclescco = loadable(() =>
  import('modules/reports/comparevehiclescco/components/Comparevehiclescco'),
)
const Parkingareaoutside = loadable(() =>
  import('modules/reports/parkingareaoutside/components/Parking'),
)
const Parking = loadable(() =>
  import('modules/reports/parking/components/Parking'),
)
const Drivinglicensescanlog = loadable(() =>
  import(
    'modules/reports/drivinglicensescanlog/components/Drivinglicensescanlog'
  ),
)
const Speedoverlimitsummary = loadable(() =>
  import(
    'modules/reports/speedoverlimitsummary/components/Speedoverlimitsummary'
  ),
)
const Drivinglog = loadable(() =>
  import('modules/reports/drivinglog/components/Drivinglog'),
)
const Event = loadable(() => import('modules/reports/event/components/Event'))
const SafetyEvent = loadable(() =>
  import('modules/reports/safetyEvent/components/SafetyEvent'),
)
const Summarykpi = loadable(() =>
  import('modules/reports/summarykpi/components/Summarykpi'),
)
const AlarmalertbydriverNewformet = loadable(() =>
  import(
    'modules/reports/alarmalertfrequencybydriver/components/AlarmalertNewformet'
  ),
)
const Loginhistory = loadable(() =>
  import('modules/reports/loginhistory/components/Loginhistory'),
)
const Gpsstatus = loadable(() =>
  import('modules/reports/gpsstatus/components/Gpsstatus'),
)

const Trackingdata = loadable(() =>
  import('modules/reports/trackingdata/components/Trackingdata'),
)

const Truckusage = loadable(() =>
  import('modules/reports/truckusage/components/Truckusage'),
)

const Drivingdistance = loadable(() =>
  import('modules/reports/drivingdistance/components/Drivingdistance'),
)

const Temperature = loadable(() =>
  import('modules/reports/temperature/components/Temperature'),
)

const Maintenance = loadable(() =>
  import('modules/reports/maintenance/components/Maintenance'),
)

const Distfromlastmaintenance = loadable(() =>
  import(
    'modules/reports/distfromlastmaintenance/components/Distfromlastmaintenance'
  ),
)

const Truckcurrentlocation = loadable(() =>
  import(
    'modules/reports/truckcurrentlocation/components/Truckcurrentlocation'
  ),
)

const Driverinformation = loadable(() =>
  import('modules/reports/driverinformation/components/Driverinformation'),
)

const Numberofdaysworked = loadable(() =>
  import('modules/reports/numberofdaysworked/components/Numberofdaysworked'),
)

const Dozeoffrisk = loadable(() =>
  import('modules/reports/dozeoffrisk/components/Dozeoffrisk'),
)

const Delivery = loadable(() =>
  import('modules/reports/delivery/components/Delivery'),
)

const Tripsumbyveh = loadable(() =>
  import('modules/reports/tripsumbyveh/components/Tripsumbyveh'),
)

const Triptemperature = loadable(() =>
  import('modules/reports/triptemperature/components/Triptemperature'),
)

const Daily = loadable(() => import('modules/reports/daily/components/Daily'))

const Velocitysummary = loadable(() =>
  import('modules/reports/velocitysummary/components/Velocitysummary'),
)

const Truckengineon = loadable(() =>
  import('modules/reports/truckengineon/components/Truckengineon'),
)

const Truckengineoff = loadable(() =>
  import('modules/reports/truckengineoff/components/Truckengineoff'),
)

const Trucknotuse = loadable(() =>
  import('modules/reports/trucknotuse/components/Trucknotuse'),
)

const Drivinghour = loadable(() =>
  import('modules/reports/drivinghour/components/Drivinghour'),
)

const Tripsummary = loadable(() =>
  import('modules/reports/tripsummary/components/Tripsummary'),
)

const Drivingoverlimit = loadable(() =>
  import('modules/reports/drivingoverlimit/components/Drivingoverlimit'),
)

const Tripsumbylocation = loadable(() =>
  import('modules/reports/tripsumbylocation/components/Tripsumbylocation'),
)

const Insurance = loadable(() =>
  import('modules/reports/insurance/components/Insurance'),
)

const Vehicleperformanceconclude = loadable(() =>
  import(
    'modules/reports/vehicleperformanceconclude/components/Vehicleperformanceconclude'
  ),
)

const Refuel = loadable(() =>
  import('modules/reports/refuel/components/Refuel'),
)

const Riskbehaviour = loadable(() =>
  import('modules/reports/riskbehaviour/components/Riskbehaviour'),
)

const Vehicleinarea = loadable(() =>
  import('modules/reports/vehicleinarea/components/Vehicleinarea'),
)

const Maintenancedeviceconclude = loadable(() =>
  import(
    'modules/reports/maintenancedeviceconclude/components/Maintenancedeviceconclude'
  ),
)

//management
const Downloadcertificate = loadable(() =>
  import(
    'modules/management/downloadcertificate/components/Downloadcertificate'
  ),
)

// notification
const NotificationCenter = loadable(() =>
  import('modules/ui/components/NotificationCenter'),
)
// dashboard
const Tracking = loadable(() =>
  import('modules/monitoring/tracking/components/Tracking'),
)
const DashCameras = loadable(() =>
  import('modules/monitoring/dash-cameras/components/DashCameras'),
)
const AlertAlarm = loadable(() =>
  import('modules/monitoring/alert-alarm/components/AlertAlarm'),
)

const BookingOverview = loadable(() =>
  import('modules/monitoring/booking-overview/components/BookingOverview'),
)
const CashingOverview = loadable(() =>
  import('modules/monitoring/cashing-overview/components/CashingOverview'),
)
const EventMap = loadable(() =>
  import('modules/monitoring/event-map/components/EventMap'),
)
const ConcreteDelivery = loadable(() =>
  import('modules/monitoring/concrete-delivery/components/ConcreteDelivery'),
)
const ConcreteDeliveryManager = loadable(() =>
  import(
    'modules/monitoring/concrete-delivery-manager/components/ConcreteDeliveryManager'
  ),
)
const ConcreteDeliveryManagerV2 = loadable(() =>
  import(
    'modules/monitoring/concrete-delivery-manager-v2/components/ConcreteDeliveryManagerV2'
  ),
)

const Replay = loadable(() =>
  import('modules/monitoring/replaynew/components/Replay'),
)

const DriverKpi = loadable(() =>
  import('modules/monitoring/driver-kpi/components/DriverKPI'),
)

const Trip = loadable(() =>
  import('modules/delivery-management/trip/components/Trip'),
)

const IsupplyDelivery = loadable(() =>
  import('modules/monitoring/isupply-delivery/components/Overview'),
)

// master data
const Customer = loadable(() =>
  import('modules/master-data/customer/components/Customer'),
)
const Usergroup = loadable(() =>
  import('modules/master-data/usergroup/components/Usergroup'),
)
const Pullvehiclesink = loadable(() =>
  import('modules/master-data/pullvehiclesink/components/Pullvehiclesink'),
)
const Permission = loadable(() =>
  import('modules/master-data/permission/components/Permission'),
)

const VehicleGroupOwerview = loadable(() =>
  import('modules/master-data/vehicleGroup/components/VehicleGroupOwerview'),
)
const RouteOverview = loadable(() =>
  import('modules/master-data/route/components/RouteOverview'),
)
const VehicleSharing = loadable(() =>
  import('modules/master-data/vehicle-sharing/components/VehicleSharing'),
)
const Facility = loadable(() =>
  import('modules/master-data/facility/components/FacilityOverviwe'),
)
const Vehicle = loadable(() =>
  import('modules/master-data/vehicle/components/VehicleOverview'),
)
const DriverUser = loadable(() =>
  import('modules/master-data/deviceuser/components/DeviceUserOverview'),
)
const LocationGroup = loadable(() =>
  import('modules/master-data/locationgroup/components/LocationGroupOverview'),
)
const SiteGroup = loadable(() =>
  import('modules/master-data/sitegroup/components/SiteGroupOverview'),
)
const SubLocation = loadable(() =>
  import('modules/master-data/sublocation/components/SubLocationOverview'),
)
const NearbyLocation = loadable(() =>
  import(
    'modules/master-data/nearbylocation/componants/NearByLocationOverview'
  ),
)
const Zone = loadable(() =>
  import('modules/master-data/zone/components/ZoneOverview'),
)
const User = loadable(() =>
  import('modules/master-data/user/components/UserOverview'),
)

const Verifyemail = loadable(() =>
  import('modules/master-data/verifyemail/components/verifyemailOverview'),
)
const Refeul = loadable(() =>
  import('modules/master-data/refuel/components/RefuelOverview'),
)
const Partner = loadable(() =>
  import('modules/master-data/partner/components/PartnerOverview'),
)
const LocationSharing = loadable(() =>
  import(
    'modules/master-data/locations-sharing/components/LocationSharingOverview'
  ),
)
const PartType = loadable(() =>
  import('modules/master-data/parttype/components/PartTypeOverview'),
)
const PartGroup = loadable(() =>
  import('modules/master-data/partgroup/components/PartGroupOverview'),
)
const ManagementMaintenance = loadable(() =>
  import('modules/master-data/maintenance/components/MainntenencsOverview'),
)
const ExpenseInsurance = loadable(() =>
  import('modules/master-data/insurance/components/InsuranceOverview'),
)

const Company = loadable(() =>
  import('modules/master-data/company/components/CompanyOverview'),
)

const ServiceMoveDevice = loadable(() =>
  import('modules/help/servicemovedevice/components/ServiceMoveDeviceOverview'),
)
const ServiceInstallDevice = loadable(() =>
  import(
    'modules/help/serviceeinstalldevice/components/ServiceinstallOverview'
  ),
)

// booking
const CenterPool = loadable(() =>
  import('modules/booking-pool/center-pool/components/CenterPool'),
)
const FinishedPool = loadable(() =>
  import('modules/booking-pool/finished-pool/components/FinishedPool'),
)
const CancelledPool = loadable(() =>
  import('modules/booking-pool/cancelled-pool/components/CancelledPool'),
)
const CashReceived = loadable(() =>
  import('modules/cashier/cash-received/components/CashReceived'),
)
const ReceiveHistory = loadable(() =>
  import('modules/cashier/receive-history/components/ReceiveHistory'),
)

// operation job
const Announcement = loadable(() =>
  import(
    'modules/operate-job/announcement/announcement-broadcast/components/Announcement'
  ),
)

const CpacPolicy = loadable(() =>
  import('modules/GPS-Dashborad/gps-policy/components/Policy'),
)

const CpacRequestcertificate = loadable(() =>
  import(
    'modules/GPS-Dashborad/requestcertificate/components/RequestCertificateOverview'
  ),
)

const IsupplyRequestMaterial = loadable(() =>
  import('modules/master-data/request-material/components/Overview'),
)

const IsupplyManageQueue = loadable(() =>
  import('modules/management/isupply-manage-queue/components/Overview'),
)

const IsupplyDailyQueue = loadable(() =>
  import('modules/monitoring/request-material-to-day/components/Overview'),
)

const IsupplyVehicleBlaclist = loadable(() =>
  import('modules/management/isupply_vehicle_blacklist/components/overview'),
)

const IsupplyDriverBlaclist = loadable(() =>
  import('modules/management/isupply_driver_blacklist/components/overview'),
)

const VehicleVisibilityPermission = loadable(() =>
  import(
    'modules/management/vehicleVisibilityPermission/VehicleVisibilityPermission'
  ),
)

const VehicleVisibilityPermissionGeneralData = loadable(() =>
  import(
    'modules/management/vehicleVisibilityPermissionGeneralData/VehicleVisibilityPermissionGeneralData'
  ),
)

const IsupplyPlantMiningContract = loadable(() =>
  import(
    'modules/master-data/isupply_plant_mining_contract/components/Overview'
  ),
)

const IsupplyDeliveryReport = loadable(() =>
  import('modules/reports/isupply-delivery-report/components/Overview'),
)

const IsupplyManageVehicle = loadable(() =>
  import('modules/management/isupply-manage-vehicle/components/Overview'),
)

const PrecastTransportationInformationWall = loadable(() =>
  import(
    'modules/management/cpac-precast-transportation-information-wall/components/Overview'
  ),
)

const PrecastTransportationInformationFloor = loadable(() =>
  import(
    'modules/management/cpac-precast-transportation-information-floor/components/Overview'
  ),
)

const PrecastSalesCloseInformation = loadable(() =>
  import('modules/management/cpac-sales-close-information/components/Overview'),
)

const PrecastReport = loadable(() =>
  import('modules/reports/cpac-precast/components/Overview'),
)
const IsupplyVehicleStatusDailyJobs = loadable(() =>
  import(
    'modules/monitoring/isupply-vehicle-status-daily-jobs/components/Overview'
  ),
)
const IsupplyOverviewPerformanceDashboard = loadable(() =>
  import(
    'modules/monitoring/isupply_overiew_performance_dashboard/components/Overview'
  ),
)
const Fuelremainrate = loadable(() =>
  import('modules/reports/fuelremainrate/components/fuelRemainRate'),
)

const Tripbyengineoffon = loadable(() =>
  import('modules/reports/tripbyengineoffon/components/Tripbyengineoffon'),
)

const Rmcconcratetrip = loadable(() =>
  import('modules/reports/rmcconcretetrip/componants/Overview'),
)

const Unauthorizeunload = loadable(() =>
  import('modules/reports/unauthorizeunload/components/Overview'),
)

const AutoMoveSiteReport = loadable(() =>
  import('modules/reports/automovesite/components/Overview'),
)

const Dailydrivingsummaryreport = loadable(() =>
  import('modules/reports/daily-driving-summary-report/components/Overview'),
)
const GPSLostContactReport = loadable(() =>
  import('modules/reports/gps-lost-contact/components/Overview'),
)
const ActionLog = loadable(() =>
  import('modules/monitoring/action-log/components/Overview'),
)
const SccoWebserviceLog = loadable(() =>
  import(
    'modules/monitoring/scco-webservice-log/components/SccoWebserviceLogOverview'
  ),
)
const IsupplyMaterial = loadable(() =>
  import('modules/master-data/material/components/Overview'),
)
const GpsDisconnectOnTriptReport = loadable(() =>
  import('modules/reports/gpsdisconnectontrip/components/Overview'),
)
const IsupplyWeightHistory = loadable(() =>
  import('modules/reports/isupply-weighing-history/components/Overview'),
)
const VehicleType = loadable(() =>
  import('modules/master-data/vehicleType/componente/Overview'),
)

const BookingKeyCdas = loadable(() =>
  import('modules/master-data/booking-key-cdas/components/Overview'),
)
const Truckincorrectpoint = loadable(() =>
  import('modules/monitoring/truck-incorrect-point/components/Index.js'),
)

const SubMaterial = loadable(() =>
  import('modules/master-data/sub_material/componant/Overview'),
)

const UpdateImei = loadable(() =>
  import('modules/help/updateimei/components/UpdateImeiOverview'),
)

const UpdateVechicle = loadable(() =>
  import('modules/help/updatevehicle/components/UpdateVehicleOverview'),
)

const IsupplyMultidrop = loadable(() =>
  import('modules/master-data/isupply-multidrop/component/Overview'),
)

const IsupplySampleImage = loadable(() =>
  import('modules/master-data/format-sample-image/components/Overview'),
)

const TrucksPickupCard = loadable(() =>
  import('modules/master-data/trucks-pickup-card/components/Overview'),
)

const BookingDashboard = loadable(() =>
  import('modules/monitoring/isupply_booking_dashboard/components/Overview'),
)
const BookingOrder = loadable(() =>
  import('modules/master-data/isupply-booking-order/component/Overview'),
)

const IsupplySaleorder = loadable(() =>
  import('modules/master-data/isupply-saleorder/components/Overview'),
)

const ViewPermission = loadable(() =>
  import('modules/help/viewpermission/components/ViewPermissionOverview'),
)

const AutoMoveSiteOverview = loadable(() =>
  import('modules/monitoring/automovesite/AutoMoveSiteOverview'),
)

const TruckRouteMapOverview = loadable(() =>
  import('modules/monitoring/truck-route-map/TruckRouteMapOverview'),
)

const AccountVehicleListHistory = loadable(() =>
  import(
    'modules/master-data/vehicle-sharing-system-avaliable-account/account-vehicle-list-history/Overview.js'
  ),
)
const ContractorVehicleManagement = loadable(() =>
  import(
    'modules/master-data/vehicle-sharing-system-avaliable-account/contractor-vehicle-management/Overview.js'
  ),
)

const ListOfVehicleAccount = loadable(() =>
  import(
    'modules/master-data/vehicle-sharing-system-avaliable-account/list-of-vehicle-account/Overview.js'
  ),
)

const ApproveRequestToUseVehicle = loadable(() =>
  import(
    'modules/master-data/vehicle-sharing-system-avaliable-account/approve-request-to-use-vehicle/Overview.js'
  ),
)

const MonitorGPS = loadable(() =>
  import('modules/monitoring/monitor-gps/components/Overview'),
)
const CameraCheckStatus = loadable(() =>
  import('modules/monitoring/camera-check-status/components/Index'),
)

const InterfaceMonitoring = loadable(() =>
  import('modules/help/interface-monitoring/components/Overview'),
)

const DynamicSidebar = loadable(() =>
  import('modules/master-data/dynamic-sidebar/components/Overview'),
)

const DashboardQtft = loadable(() => import('modules/dashboard-qtft/Overviews'))

const GPSServiceRequests = loadable(() =>
  import('modules/help/gps-service-requests/components/Overview'),
)

const GpsMonthlyUsage = loadable(() =>
  import('modules/help/gps-monthly-usage/components/Index'),
)

const SignatureImage = loadable(() =>
  import('modules/master-data/signature-image/components/Overview'),
)

const DepartmentCostSetup = loadable(() =>
  import('modules/master-data/department-cost-setup/components/Overview'),
)

const GPSVendorCostSetup = loadable(() =>
  import('modules/master-data/gps-vendor-cost-setup/components/Overview'),
)

const AccountingCodeSetup = loadable(() =>
  import('modules/master-data/accounting-code-setup/components/Overview'),
)

const MasterDataPaymentSetup = loadable(() =>
  import('modules/master-data/payment-setup/components/Index'),
)

const CpacOperationContractor = loadable(() =>
  import('modules/reports/cpac-operation/contractor/components/Overview'),
)

const CpacOperationChain = loadable(() =>
  import('modules/reports/cpac-operation/chain/components/Overview'),
)

const CpacOperationVendor = loadable(() =>
  import('modules/reports/cpac-operation/vendor/components/Overview'),
)

const GPSDeviceListSetup = loadable(() =>
  import('modules/master-data/gps-device-list-setup/components/Overview'),
)

const GPSContractorSetup = loadable(() =>
  import('modules/master-data/gps-contractor-setup/components/Overview'),
)

const GPSDeviceTracker = loadable(() =>
  import('modules/master-data/gps-device-tracker/components/Overview'),
)

const LayerMap = loadable(() =>
  import('modules/master-data/layer-map/components/Overview'),
)

class Layout extends Component {
  langMap = {
    th: localeTh,
    en: localeEn,
  }

  changeLang = inputLng => {
    this.props.setLanguageChange(inputLng)
  }

  componentDidMount() {
    this.props.loadCredentials()
  }

  renderContent() {
    const { done, location, path } = this.props
    const pathname = location.pathname

    if (pathname.startsWith('/automovesite')) {
      return <AutoMoveSiteOverview />
    }

    if (pathname === '/truck-route-map') {
      return <TruckRouteMapOverview />
    }

    if (pathname === '/verifyemail/check') {
      return <Verifyemail />
    }

    if (!done) {
      return <OauthLogin auth={path} />
    }

    // login อยู่แล้ว แต่มี redirect param → redirect ทันที
    if (pathname === '/logincpac') {
      const params = new URLSearchParams(location.search)
      const redirectParam = params.get('redirect')
      if (redirectParam) {
        window.location.replace(redirectParam)
        return null
      }
    }

    if (pathname.includes('logistic-command-center')) {
      return <LogisticCommandCenter />
    }

    return (
      <NotificationProvider>
        <AppLayout style={{ minHeight: '100vh' }}>
          <Header changeLang={this.changeLang} />

          <Switch>
            {/* DEPRECATED route (no longer used): /truckincorrectpoint
                    <PrivateRoute
                        key="/truckincorrectpoint"
                        path="/truckincorrectpoint"
                        component={Truckincorrectpoint}
                        done={done}
                    />
                    */}
            <PrivateRoute
              key="/profile"
              path="/profile"
              component={Profile}
              done={done}
            />
            <PrivateRoute
              key="/notification"
              path="/notification"
              component={NotificationCenter}
              done={done}
            />
            <PrivateRoute
              key="/center_pool"
              path="/center_pool"
              component={CenterPool}
              done={done}
            />
            <PrivateRoute
              key="/finished_pool"
              path="/finished_pool"
              component={FinishedPool}
              done={done}
            />
            <PrivateRoute
              key="/cancelled_pool"
              path="/cancelled_pool"
              component={CancelledPool}
              done={done}
            />
            <PrivateRoute
              key="/tracking"
              path="/tracking"
              component={Tracking}
              done={done}
            />
            <PrivateRoute
              key="/dash_cameras"
              path="/dash_cameras"
              component={DashCameras}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /alert_alarm
                    <PrivateRoute
                        key="/alert_alarm"
                        path="/alert_alarm"
                        component={AlertAlarm}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /booking_overview
                    <PrivateRoute
                        key="/booking_overview"
                        path="/booking_overview"
                        component={BookingOverview}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /cashing_overview
                    <PrivateRoute
                        key="/cashing_overview"
                        path="/cashing_overview"
                        component={CashingOverview}
                        done={done}
                    />
                    */}
            <PrivateRoute
              key="/cash_received"
              path="/cash_received"
              component={CashReceived}
              done={done}
            />
            <PrivateRoute
              key="/receive_history"
              path="/receive_history"
              component={ReceiveHistory}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /customer
                    <PrivateRoute
                        key="/customer"
                        path="/customer"
                        component={Customer}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/usergroup"
              path="/usergroup"
              component={Usergroup}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /report/alarmalertbyplateno
                    <PrivateRoute
                        key="/report/alarmalertbyplateno"
                        path="/report/alarmalertbyplateno"
                        component={Alarmalertbyplateno}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/alarmalertbydriver
                    <PrivateRoute
                        key="/report/alarmalertbydriver"
                        path="/report/alarmalertbydriver"
                        component={Alarmalertbydriver}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /report/alarmalertfrequencybydriver
                    <PrivateRoute
                        key="/report/alarmalertfrequencybydriver"
                        path="/report/alarmalertfrequencybydriver"
                        component={AlarmalertbydriverNewformet}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /report/alarmalertbydurationtime
                    <PrivateRoute
                        key="/report/alarmalertbydurationtime"
                        path="/report/alarmalertbydurationtime"
                        component={Alarmalertbydurationtime}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /report/drivingbehavior
                    <PrivateRoute
                        key="/report/drivingbehavior"
                        path="/report/drivingbehavior"
                        component={Drivingbehavior}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /report/drivinglicensescanbehavior
                    <PrivateRoute
                        key="/report/drivinglicensescanbehavior"
                        path="/report/drivinglicensescanbehavior"
                        component={Drivinglicensescanbehavior}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /report/alarmalertbyplatenoonyear
                    <PrivateRoute
                        key="/report/alarmalertbyplatenoonyear"
                        path="/report/alarmalertbyplatenoonyear"
                        component={Alarmalertbyplatenoonyear}
                        done={done}
                    />
                    */}
            <PrivateRoute
              key="/report/separatevehiclestatus"
              path="/report/separatevehiclestatus"
              component={Separatevehiclestatus}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /announcement_broadcast
                    <PrivateRoute
                        key="/announcement_broadcast"
                        path="/announcement_broadcast"
                        component={Announcement}
                        done={done}
                    />
                    */}
            {/* DEPRECATED route (no longer used): /event_map
                    <PrivateRoute
                        key="/event_map"
                        path="/event_map"
                        component={EventMap}
                        done={done}
                    />
                    */}
            {/* v2 ต้องมาก่อน v1 เพราะ Switch เลือก route แรกที่ match */}
            <PrivateRoute
              key="/concrete-delivery-manager"
              path="/concrete-delivery-manager"
              component={ConcreteDeliveryManagerV2}
              done={done}
            />
            {/* <PrivateRoute
              key="/concrete_delivery_manager"
              path="/concrete_delivery_manager"
              component={ConcreteDeliveryManager}
              done={done}
            /> */}
            <PrivateRoute
              key="/concrete_delivery"
              path="/concrete_delivery"
              component={ConcreteDelivery}
              done={done}
            />
            <PrivateRoute
              key="/replay"
              path="/replay"
              component={Replay}
              done={done}
            />
            <PrivateRoute
              key="/driver-kpi"
              path="/driver-kpi"
              component={DriverKpi}
              done={done}
            />
            <PrivateRoute
              key="/report/comparevehiclescco"
              path="/report/comparevehiclescco"
              component={Comparevehiclescco}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /report/parkingareaoutside
                    <PrivateRoute
                        key="/report/parkingareaoutside"
                        path="/report/parkingareaoutside"
                        component={Parkingareaoutside}
                        done={done}
                    />
                    */}
            <PrivateRoute
              key="/pullvehiclesink"
              path="/pullvehiclesink"
              component={Pullvehiclesink}
              done={done}
            />
            <PrivateRoute
              key="/location"
              path="/location"
              component={Facility}
              done={done}
            />
            <PrivateRoute
              key="/user"
              path="/user"
              component={User}
              done={done}
            />
            <PrivateRoute
              key="/generateusertoken"
              path="/generateusertoken"
              component={GenerateUserToken}
              done={done}
            />
            <PrivateRoute
              key="/vehiclegroup"
              path="/vehiclegroup"
              component={VehicleGroupOwerview}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /route
                    <PrivateRoute
                        key="/route"
                        path="/route"
                        component={RouteOverview}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/vehicle"
              path="/vehicle"
              component={Vehicle}
              done={done}
            />

            <PrivateRoute
              key="/report/parking"
              path="/report/parking"
              component={Parking}
              done={done}
            />

            <PrivateRoute
              key="/report/drivinglicensescanlog"
              path="/report/drivinglicensescanlog"
              component={Drivinglicensescanlog}
              done={done}
            />

            <PrivateRoute
              exact
              key="/"
              path="/"
              component={HomeDashboard}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/speedoverlimitsummary
                    <PrivateRoute
                        key="/report/speedoverlimitsummary"
                        path="/report/speedoverlimitsummary"
                        component={Speedoverlimitsummary}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/drivinglog"
              path="/report/drivinglog"
              component={Drivinglog}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/event
                    <PrivateRoute
                        key="/report/event"
                        path="/report/event"
                        component={Event}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/safety_event"
              path="/report/safety_event"
              component={SafetyEvent}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/summarykpi
                    <PrivateRoute
                        key="/report/summarykpi"
                        path="/report/summarykpi"
                        component={Summarykpi}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/permission"
              path="/permission"
              component={Permission}
              done={done}
            />

            <PrivateRoute
              key="/vehicle_sharing"
              path="/vehicle_sharing"
              component={VehicleSharing}
              done={done}
            />

            <PrivateRoute
              key="/drivingdistance"
              path="/drivingdistance"
              component={Drivingdistance}
              done={done}
            />

            <PrivateRoute
              key="/datavisibility"
              path="/datavisibility"
              component={Datavisibility}
              done={done}
            />

            <PrivateRoute
              key="/report/loginhistory"
              path="/report/loginhistory"
              component={Loginhistory}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/gpsstatus
                    <PrivateRoute
                        key="/report/gpsstatus"
                        path="/report/gpsstatus"
                        component={Gpsstatus}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/trackingdata
                    <PrivateRoute
                        key="/report/trackingdata"
                        path="/report/trackingdata"
                        component={Trackingdata}
                        done={done}
                    />
                    */}

            {/* <PrivateRoute
                      key="/verifyemail"
                      path="/verifyemail"
                      component={Verifyemail}
                      done={done}
                    /> */}

            {/* DEPRECATED route (no longer used): /deviceuser
                    <PrivateRoute
                        key="/deviceuser"
                        path="/deviceuser"
                        component={DriverUser}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/locationgroup"
              path="/locationgroup"
              component={LocationGroup}
              done={done}
            />

            <PrivateRoute
              key="/sitegroup"
              path="/sitegroup"
              component={SiteGroup}
              done={done}
            />

            <PrivateRoute
              key="/sublocation"
              path="/sublocation"
              component={SubLocation}
              done={done}
            />

            <PrivateRoute
              key="/nearbylocation"
              path="/nearbylocation"
              component={NearbyLocation}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /refuel
                    <PrivateRoute
                        key="/refuel"
                        path="/refuel"
                        component={Refeul}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/truckusage"
              path="/report/truckusage"
              component={Truckusage}
              done={done}
            />

            <PrivateRoute
              key="/report/drivingdistance"
              path="/report/drivingdistance"
              component={Drivingdistance}
              done={done}
            />

            <PrivateRoute
              key="/report/temperature"
              path="/report/temperature"
              component={Temperature}
              done={done}
            />

            <PrivateRoute
              key="/report/maintenance"
              path="/report/maintenance"
              component={Maintenance}
              done={done}
            />

            <PrivateRoute
              key="/report/distfromlastmaintenance"
              path="/report/distfromlastmaintenance"
              component={Distfromlastmaintenance}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/truckcurrentlocation
                    <PrivateRoute
                        key="/report/truckcurrentlocation"
                        path="/report/truckcurrentlocation"
                        component={Truckcurrentlocation}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/driverinformation
                    <PrivateRoute
                        key="/report/driverinformation"
                        path="/report/driverinformation"
                        component={Driverinformation}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/numberofdaysworked"
              path="/report/numberofdaysworked"
              component={Numberofdaysworked}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/dozeoffrisk
                    <PrivateRoute
                        key="/report/dozeoffrisk"
                        path="/report/dozeoffrisk"
                        component={Dozeoffrisk}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/delivery"
              path="/report/delivery"
              component={Delivery}
              done={done}
            />

            <PrivateRoute
              key="/report/triptemperature"
              path="/report/triptemperature"
              component={Triptemperature}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/tripsumbyveh
                    <PrivateRoute
                        key="/report/tripsumbyveh"
                        path="/report/tripsumbyveh"
                        component={Tripsumbyveh}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/daily
                    <PrivateRoute
                        key="/report/daily"
                        path="/report/daily"
                        component={Daily}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/velocitysummary"
              path="/report/velocitysummary"
              component={Velocitysummary}
              done={done}
            />

            <PrivateRoute
              key="/report/truckengineon"
              path="/report/truckengineon"
              component={Truckengineon}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/truckengineoff
                    <PrivateRoute
                        key="/report/truckengineoff"
                        path="/report/truckengineoff"
                        component={Truckengineoff}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/drivinghour"
              path="/report/drivinghour"
              component={Drivinghour}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/tripsummary
                    <PrivateRoute
                        key="/report/tripsummary"
                        path="/report/tripsummary"
                        component={Tripsummary}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/drivingoverlimit
                    <PrivateRoute
                        key="/report/drivingoverlimit"
                        path="/report/drivingoverlimit"
                        component={Drivingoverlimit}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/tripsumbylocation
                    <PrivateRoute
                        key="/report/tripsumbylocation"
                        path="/report/tripsumbylocation"
                        component={Tripsumbylocation}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/insurance
                    <PrivateRoute
                        key="/report/insurance"
                        path="/report/insurance"
                        component={Insurance}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/vehicleperformanceconclude"
              path="/report/vehicleperformanceconclude"
              component={Vehicleperformanceconclude}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /report/refuel
                    <PrivateRoute
                        key="/report/refuel"
                        path="/report/refuel"
                        component={Refuel}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/trucknotuse
                    <PrivateRoute
                        key="/report/trucknotuse"
                        path="/report/trucknotuse"
                        component={Trucknotuse}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/riskbehaviour
                    <PrivateRoute
                        key="/report/riskbehaviour"
                        path="/report/riskbehaviour"
                        component={Riskbehaviour}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /partner
                    <PrivateRoute
                        key="/partner"
                        path="/partner"
                        component={Partner}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /sharelocation
                    <PrivateRoute
                        key="/sharelocation"
                        path="/sharelocation"
                        component={LocationSharing}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /report/vehicleinarea
                    <PrivateRoute
                        key="/report/vehicleinarea"
                        path="/report/vehicleinarea"
                        component={Vehicleinarea}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/maintenancedeviceconclude"
              path="/report/maintenancedeviceconclude"
              component={Maintenancedeviceconclude}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /zone
                    <PrivateRoute key="/zone" path="/zone" component={Zone} done={done} />
                    */}
            {/* DEPRECATED route (no longer used): /trip
                    <PrivateRoute key="/trip" path="/trip" component={Trip} done={done} />
                    */}
            <PrivateRoute
              key="/policy"
              path="/policy"
              component={Policy}
              done={done}
            />
            <PrivateRoute
              key="/notification-setting"
              path="/notification-setting"
              component={NotificationSetting}
              done={done}
            />
            <PrivateRoute
              key="/parttype"
              path="/parttype"
              component={PartType}
              done={done}
            />
            <PrivateRoute
              key="/partgroup"
              path="/partgroup"
              component={PartGroup}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /maintenance
                    <PrivateRoute
                        key="/maintenance"
                        path="/maintenance"
                        component={ManagementMaintenance}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/management/downloadcertificate"
              path="/management/downloadcertificate"
              component={Downloadcertificate}
              done={done}
            />

            <PrivateRoute
              key="/management/contactmanagement"
              path="/management/contactmanagement"
              component={Contactmanagement}
              done={done}
            />

            <PrivateRoute
              key="/servicerepairdevice"
              path="/servicerepairdevice"
              component={Servicerepairdevice}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /deliverytrip
                    <PrivateRoute
                        key="/deliverytrip"
                        path="/deliverytrip"
                        component={Deliverytrip}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/insurance"
              path="/insurance"
              component={ExpenseInsurance}
              done={done}
            />

            <PrivateRoute
              key="/company"
              path="/company"
              component={Company}
              done={done}
            />

            <PrivateRoute
              key="/servicemovedevice"
              path="/servicemovedevice"
              component={ServiceMoveDevice}
              done={done}
            />

            <PrivateRoute
              key="/report/vehicleinformationdlt"
              path="/report/vehicleinformationdlt"
              component={Vehicleinformationdlt}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastlivestream"
              path="/honeytoastlivestream"
              component={Honeytoaststream}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastlivestream-v2"
              path="/honeytoastlivestream-v2"
              component={HoneytoaststreamV2}
              done={done}
            />

            <PrivateRoute
              key="/serviceinstalldevice"
              path="/serviceinstalldevice"
              component={ServiceInstallDevice}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastdownloadfile"
              path="/honeytoastdownloadfile"
              component={Honeytoastdownloadfile}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastdownloadfilewebpage"
              path="/honeytoastdownloadfilewebpage"
              component={Honeytoastdownloadfilewebpage}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastplayback"
              path="/honeytoastplayback"
              component={Honeytoastplayback}
              done={done}
            />

            <PrivateRoute
              key="/honeytoastplaybackwebpage"
              path="/honeytoastplaybackwebpage"
              component={Honeytoastplaybackwebpage}
              done={done}
            />

            <PrivateRoute
              key="/safety_dashboard"
              path="/safety_dashboard"
              component={SafetyDashboard}
              done={done}
            />

            <PrivateRoute
              key="/gps_performance_dashboard"
              path="/gps_performance_dashboard"
              component={GpsPerformanceDashboard}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /summary_dashboard
                    <PrivateRoute
                        key="/summary_dashboard"
                        path="/summary_dashboard"
                        component={SummaryDashboard}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/cpac-policy"
              path="/cpac-policy"
              component={CpacPolicy}
              done={done}
            />

            <PrivateRoute
              key="/report/behaviordriving"
              path="/report/behaviordriving"
              component={Behaviordriving}
              done={done}
            />

            <PrivateRoute
              key="/report/scoresummary"
              path="/report/scoresummary"
              component={Scoresummary}
              done={done}
            />

            <PrivateRoute
              key="/report/behaviordrivingbycompany"
              path="/report/behaviordrivingbycompany"
              component={Behaviordrivingbycompany}
              done={done}
            />

            <PrivateRoute
              key="/cpac-requestcertificate"
              path="/cpac-requestcertificate"
              component={CpacRequestcertificate}
              done={done}
            />

            <PrivateRoute
              key="/maintenancedevice"
              path="/maintenancedevice"
              component={Maintenancedevice}
              done={done}
            />

            <PrivateRoute
              key="/report/repairingreport"
              path="/report/repairingreport"
              component={RepairingReport}
              done={done}
            />
            <PrivateRoute
              key="/report/partnerperformreport"
              path="/report/partnerperformreport"
              component={PartnerPerformReport}
              done={done}
            />
            <PrivateRoute
              key="/report/gpsvendorpayingsummaryreport"
              path="/report/gpsvendorpayingsummaryreport"
              component={GpsVendorPayingSummaryReport}
              done={done}
            />

            <PrivateRoute
              key="/report/gpsvendorpayingreport"
              path="/report/gpsvendorpayingreport"
              component={GpsVendorPayingReport}
              done={done}
            />

            <PrivateRoute
              key="/fuel-notification"
              path="/fuel-notification"
              component={FuelNotification}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /request-material
                    <PrivateRoute
                        key="/request-material"
                        path="/request-material"
                        component={IsupplyRequestMaterial}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/isupply-delivery"
              path="/isupply-delivery"
              component={IsupplyDelivery}
              done={done}
            />

            <PrivateRoute
              key="/isupply-manage-queue"
              path="/isupply-manage-queue"
              component={IsupplyManageQueue}
              done={done}
            />

            <PrivateRoute
              key="/isupply-daily-request-material"
              path="/isupply-daily-request-material"
              component={IsupplyDailyQueue}
              done={done}
            />

            <PrivateRoute
              key="/isupply-vehicle-blacklist"
              path="/isupply-vehicle-blacklist"
              component={IsupplyVehicleBlaclist}
              done={done}
            />

            <PrivateRoute
              key="/isupply-driver-blacklist"
              path="/isupply-driver-blacklist"
              component={IsupplyDriverBlaclist}
              done={done}
            />

            <PrivateRoute
              key="/vehiclevisibilitypermission"
              path="/vehiclevisibilitypermission"
              component={VehicleVisibilityPermission}
              done={done}
            />

            <PrivateRoute
              key="/vehiclevisibilitypermissiongeneraldata"
              path="/vehiclevisibilitypermissiongeneraldata"
              component={VehicleVisibilityPermissionGeneralData}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /delivery-contract
                    <PrivateRoute
                        key="/delivery-contract"
                        path="/delivery-contract"
                        component={IsupplyPlantMiningContract}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/isupply-delivery-report"
              path="/isupply-delivery-report"
              component={IsupplyDeliveryReport}
              done={done}
            />

            <PrivateRoute
              key="/isupply-manage-vehicle"
              path="/isupply-manage-vehicle"
              component={IsupplyManageVehicle}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /cpac-precast-transportation-information-wall
                    <PrivateRoute
                        key="/cpac-precast-transportation-information-wall"
                        path="/cpac-precast-transportation-information-wall"
                        component={PrecastTransportationInformationWall}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /cpac-precast-transportation-information-floor
                    <PrivateRoute
                        key="/cpac-precast-transportation-information-floor"
                        path="/cpac-precast-transportation-information-floor"
                        component={PrecastTransportationInformationFloor}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/cpac-sales-close-information"
              path="/cpac-sales-close-information"
              component={PrecastSalesCloseInformation}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /precast-report
                    <PrivateRoute
                        key="/precast-report"
                        path="/precast-report"
                        component={PrecastReport}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/isupply-status-vehicles-receive-daily-jobs"
              path="/isupply-status-vehicles-receive-daily-jobs"
              component={IsupplyVehicleStatusDailyJobs}
              done={done}
            />

            <PrivateRoute
              key="/isupply-overview-performance-dashboard"
              path="/isupply-overview-performance-dashboard"
              component={IsupplyOverviewPerformanceDashboard}
              done={done}
            />

            <PrivateRoute
              key="/schedulereport"
              path="/schedulereport"
              component={Schedulereport}
              done={done}
            />

            <PrivateRoute
              key="/report/summary-fuel-usage"
              path="/report/summary-fuel-usage"
              component={SummaryVehicleUsage}
              done={done}
            />

            <PrivateRoute
              key="/report/fuelremainrate"
              path="/report/fuelremainrate"
              component={Fuelremainrate}
              done={done}
            />
            <PrivateRoute
              key="/report/tripbyengineoffon"
              path="/report/tripbyengineoffon"
              component={Tripbyengineoffon}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /routemaster
                    <PrivateRoute
                        key="/routemaster"
                        path="/routemaster"
                        component={Routemaster}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/rmcconcretetrip"
              path="/report/rmcconcretetrip"
              component={Rmcconcratetrip}
              done={done}
            />

            <PrivateRoute
              key="/report/unauthorizeunload"
              path="/report/unauthorizeunload"
              component={Unauthorizeunload}
              done={done}
            />

            <PrivateRoute
              key="/report/auto-move-site"
              path="/report/auto-move-site"
              component={AutoMoveSiteReport}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /uom
                    <PrivateRoute key="/uom" path="/uom" component={Uom} done={done} />
                    */}

            {/* DEPRECATED route (no longer used): /product
                    <PrivateRoute
                        key="/product"
                        path="/product"
                        component={Product}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/report/driving-summary"
              path="/report/driving-summary"
              component={Dailydrivingsummaryreport}
              done={done}
            />

            <PrivateRoute
              key="/report/gps-lost-contact"
              path="/report/gps-lost-contact"
              component={GPSLostContactReport}
              done={done}
            />

            <PrivateRoute
              key="/report/gps-disconnect-on-trip"
              path="/report/gps-disconnect-on-trip"
              component={GpsDisconnectOnTriptReport}
              done={done}
            />

            <PrivateRoute
              key="/report/fueluse"
              path="/report/fueluse"
              component={Fueluse}
              done={done}
            />

            <PrivateRoute
              key="/action-log"
              path="/action-log"
              component={ActionLog}
              done={done}
            />

            <PrivateRoute
              key="/webservice-log"
              path="/webservice-log"
              component={SccoWebserviceLog}
              done={done}
            />

            <PrivateRoute
              key="/linenotify"
              path="/linenotify"
              component={LineNotify}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /material
                    <PrivateRoute
                        key="/material"
                        path="/material"
                        component={IsupplyMaterial}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/isupply-weighing-history-report"
              path="/isupply-weighing-history-report"
              component={IsupplyWeightHistory}
              done={done}
            />
            <PrivateRoute
              key="truckstatusdashboard"
              path="/truckstatusdashboard"
              component={Trackingstatusdashboard}
              done={done}
            />
            <PrivateRoute
              key="smartdispatching"
              path="/smartdispatching"
              component={Smartdispatching}
              done={done}
            />
            <PrivateRoute
              key="distancereport"
              path="/report/distancereport"
              component={Distancereport}
              done={done}
            />

            <PrivateRoute
              key="WebContent"
              path="/WebContent"
              component={Webcontent}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /vehicle-type
                    <PrivateRoute
                        key="/vehicle-type"
                        path="/vehicle-type"
                        component={VehicleType}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/interface-key-cdas"
              path="/interface-key-cdas"
              component={BookingKeyCdas}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /sub-material
                    <PrivateRoute
                        key="/sub-material"
                        path="/sub-material"
                        component={SubMaterial}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/updateimei"
              path="/updateimei"
              component={UpdateImei}
              done={done}
            />

            <PrivateRoute
              key="/viewuserpermission"
              path="/viewuserpermission"
              component={ViewPermission}
              done={done}
            />

            {/* DEPRECATED route (no longer used): /updatevehicle
                    <PrivateRoute
                        key="/updatevehicle"
                        path="/updatevehicle"
                        component={UpdateVechicle}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /multidrop
                    <PrivateRoute
                        key="/multidrop"
                        path="/multidrop"
                        component={IsupplyMultidrop}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /sample-image
                    <PrivateRoute
                        key="/sample-image"
                        path="/sample-image"
                        component={IsupplySampleImage}
                        done={done}
                    />
                    */}

            {/* DEPRECATED route (no longer used): /truck-pickup-card
                    <PrivateRoute
                        key="/truck-pickup-card"
                        path="/truck-pickup-card"
                        component={TrucksPickupCard}
                        done={done}
                    />
                    */}

            <PrivateRoute
              key="/isupply-booking-scheduler/week"
              path="/isupply-booking-scheduler/week"
              component={BookingDashboard}
              done={done}
            />
            <PrivateRoute
              key="/isupply-booking-scheduler/day"
              path="/isupply-booking-scheduler/day"
              component={BookingDashboard}
              done={done}
            />
            <PrivateRoute
              key="/isupply-booking-scheduler/month"
              path="/isupply-booking-scheduler/month"
              component={BookingDashboard}
              done={done}
            />
            <PrivateRoute
              key="/booking-order"
              path="/booking-order"
              component={BookingOrder}
              done={done}
            />
            <PrivateRoute
              key="/isupply-saleorder"
              path="/isupply-saleorder"
              component={IsupplySaleorder}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /vehicle-contract
                    <PrivateRoute
                        key="/vehicle-contract"
                        path="/vehicle-contract"
                        component={VehicleContract}
                        done={done}
                    />
                    */}
            <PrivateRoute
              key="/account-vehicle-list-history"
              path="/account-vehicle-list-history"
              component={AccountVehicleListHistory}
              done={done}
            />
            <PrivateRoute
              key="/contractor-vehicle-management"
              path="/contractor-vehicle-management"
              component={ContractorVehicleManagement}
              done={done}
            />
            <PrivateRoute
              key="/list-of-vehicle-account"
              path="/list-of-vehicle-account"
              component={ListOfVehicleAccount}
              done={done}
            />
            <PrivateRoute
              key="/approve-request-to-use-vehicle"
              path="/approve-request-to-use-vehicle"
              component={ApproveRequestToUseVehicle}
              done={done}
            />

            <PrivateRoute
              key="/monitor-gps"
              path="/monitor-gps"
              component={MonitorGPS}
              done={done}
            />

            <PrivateRoute
              key="/camera-performance"
              path="/camera-performance"
              component={CameraCheckStatus}
              done={done}
            />

            <PrivateRoute
              key="/monitoring/interface-monitoring"
              path="/monitoring/interface-monitoring"
              component={InterfaceMonitoring}
              done={done}
            />
            <PrivateRoute
              key="/dynamic-sidebar"
              path="/dynamic-sidebar"
              component={DynamicSidebar}
              done={done}
            />
            {/* DEPRECATED route (no longer used): /dashboard-qtft */}
            <PrivateRoute
              key="/dashboard-qtft"
              path="/dashboard-qtft"
              component={DashboardQtft}
              done={done}
            />

            <PrivateRoute
              key="/signature-image"
              path="/signature-image"
              component={SignatureImage}
              done={done}
            />

            <PrivateRoute
              key="/gps-installation"
              path="/gps-installation"
              component={GPSServiceRequests}
              done={done}
            />

            <PrivateRoute
              key="/department-cost-setup"
              path="/department-cost-setup"
              component={DepartmentCostSetup}
              done={done}
            />

            <PrivateRoute
              key="/gps-vendor-cost-setup"
              path="/gps-vendor-cost-setup"
              component={GPSVendorCostSetup}
              done={done}
            />

            <PrivateRoute
              key="/accounting-code-setup"
              path="/accounting-code-setup"
              component={AccountingCodeSetup}
              done={done}
            />

            <PrivateRoute
              key="/master-payment-setup"
              path="/master-payment-setup"
              component={MasterDataPaymentSetup}
              done={done}
            />

            <PrivateRoute
              key="/gps-contractor-setup"
              path="/gps-contractor-setup"
              component={GPSContractorSetup}
              done={done}
            />

            <PrivateRoute
              key="/gps-device-tracker"
              path="/gps-device-tracker"
              component={GPSDeviceTracker}
              done={done}
            />

            <PrivateRoute
              key="/report/cpac-operation-contractor"
              path="/report/cpac-operation-contractor"
              component={CpacOperationContractor}
              done={done}
            />

            <PrivateRoute
              key="/report/cpac-operation-chain"
              path="/report/cpac-operation-chain"
              component={CpacOperationChain}
              done={done}
            />

            <PrivateRoute
              key="/report/cpac-operation-vendor"
              path="/report/cpac-operation-vendor"
              component={CpacOperationVendor}
              done={done}
            />

            <PrivateRoute
              key="/gps-device-list-setup"
              path="/gps-device-list-setup"
              component={GPSDeviceListSetup}
              done={done}
            />

            <PrivateRoute
              key="/gps-repair"
              path="/gps-repair"
              component={GPSServiceRequests}
              done={done}
            />

            <PrivateRoute
              key="/vehicle-type"
              path="/vehicle-type"
              component={VehicleType}
              done={done}
            />

            <PrivateRoute
              key="/gps-uninstallation"
              path="/gps-uninstallation"
              component={GPSServiceRequests}
              done={done}
            />

            <PrivateRoute
              key="/gps-monthly-usage"
              path="/gps-monthly-usage"
              component={GpsMonthlyUsage}
              done={done}
            />

            <PrivateRoute
              key="/layer-map"
              path="/layer-map"
              component={LayerMap}
              done={done}
            />
          </Switch>
          <VoicePanel />
        </AppLayout>
      </NotificationProvider>
    )
  }

  render() {
    localeTh.Transfer.itemUnit = 'item'
    localeTh.Transfer.itemsUnit = 'items'

    const { language } = this.props
    const languageKey = this.langMap[language] ? language : 'th'
    const langContextValue = i18n[languageKey] || i18n.th

    return (
      <ConfigProvider locale={this.langMap[languageKey]}>
        <LangContext.Provider value={langContextValue}>
          {this.renderContent()}
        </LangContext.Provider>
      </ConfigProvider>
    )
  }
}

const mapStateToProps = ({ auth: { done }, ui: { language } }) => ({
  done,
  language,
})
const mapDispatchToProps = {
  loadCredentials: authActions.loadCredentials,
  setLanguageChange: uiActions.setLanguageChange,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout))
